import moment from 'moment';

/**
 * Format date to DD/MM/YYYY format
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date in DD/MM/YYYY format
 */
export const formatDateDDMMYYYY = (date) => {
  if (!date) return '-';
  
  // Handle both string and Date objects
  const momentDate = moment(date);
  
  // Check if the date is valid
  if (!momentDate.isValid()) {
    return '-';
  }
  
  // Format to DD/MM/YYYY
  return momentDate.format('DD/MM/YYYY');
};

/**
 * Format date to YYYY-MM-DD format (for HTML date inputs)
 * @param {string|Date} date - Date to format
 * @returns {string} Formatted date in YYYY-MM-DD format
 */
export const formatDateYYYYMMDD = (date) => {
  if (!date) return '';
  
  const momentDate = moment(date);
  
  if (!momentDate.isValid()) {
    return '';
  }
  
  return momentDate.format('YYYY-MM-DD');
};

/**
 * Get current date in DD/MM/YYYY format
 * @returns {string} Current date in DD/MM/YYYY format
 */
export const getCurrentDateDDMMYYYY = () => {
  return moment().format('DD/MM/YYYY');
};

/**
 * Get current date in YYYY-MM-DD format (for HTML date inputs)
 * @returns {string} Current date in YYYY-MM-DD format
 */
export const getCurrentDateYYYYMMDD = () => {
  return moment().format('YYYY-MM-DD');
};

/**
 * Parse DD/MM/YYYY format to Date object
 * @param {string} dateString - Date string in DD/MM/YYYY format
 * @returns {Date|null} Parsed Date object or null if invalid
 */
export const parseDateDDMMYYYY = (dateString) => {
  if (!dateString) return null;
  
  const momentDate = moment(dateString, 'DD/MM/YYYY', true);
  
  if (!momentDate.isValid()) {
    return null;
  }
  
  return momentDate.toDate();
};
